// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2FNBr","col":"Table_col__3eOOo","fulfillmentStatus":"Table_fulfillmentStatus__13m5i","emailCol":"Table_emailCol__x4sTA"};